"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providerNotInitializedError = void 0;
const providerNotInitializedError = (caller) => () => {
    throw new Error(`Unable to perform ${caller}, Provider not initialized`);
};
exports.providerNotInitializedError = providerNotInitializedError;
//# sourceMappingURL=providerNotInitializedError.js.map